// Shared dependency-free SVG equity curve — reused by AdvancedBacktestTab (backtest
// results), HistoryPanel (all real trades), StrategyPanel (per-strategy daily PnL),
// and TradingViewAlertsTab (tv_alert-only trades). Each caller passes its own `C`
// color-theme object; only .green, .red, .muted, .faint are used.
export default function EquityCurve({ curve, initial, height = 140, C }) {
  if (!curve || curve.length < 2) return <div style={{ height, display: "flex", alignItems: "center", justifyContent: "center", color: C.muted, fontSize: 12 }}>Not enough trades</div>;
  const W = 800, H = height, PAD = { t: 10, r: 14, b: 24, l: 52 };
  const data = [initial, ...curve];
  const minV = Math.min(...data), maxV = Math.max(...data), range = maxV - minV || 1;
  const px = i => PAD.l + (i / (data.length - 1)) * (W - PAD.l - PAD.r);
  const py = v => PAD.t + (1 - (v - minV) / range) * (H - PAD.t - PAD.b);
  const pts = data.map((v, i) => `${px(i)},${py(v)}`).join(" ");
  const fillPts = `${px(0)},${py(minV)} ${pts} ${px(data.length - 1)},${py(minV)}`;
  const color = curve[curve.length - 1] >= initial ? C.green : C.red;
  const yTicks = [minV, (minV + maxV) / 2, maxV];
  return (
    <svg viewBox={`0 0 ${W} ${H}`} style={{ width: "100%", height }} preserveAspectRatio="none">
      <defs>
        <linearGradient id="eq_g" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.22" />
          <stop offset="100%" stopColor={color} stopOpacity="0.01" />
        </linearGradient>
      </defs>
      {yTicks.map((v, i) => (
        <g key={i}>
          <line x1={PAD.l} y1={py(v)} x2={W - PAD.r} y2={py(v)} stroke={C.faint} strokeWidth="1" strokeDasharray="3,4" />
          <text x={PAD.l - 5} y={py(v) + 4} fontSize="9" fill={C.muted} textAnchor="end">${v.toFixed(0)}</text>
        </g>
      ))}
      <line x1={PAD.l} y1={py(initial)} x2={W - PAD.r} y2={py(initial)} stroke={C.muted} strokeWidth="1" strokeDasharray="5,4" />
      <polygon points={fillPts} fill="url(#eq_g)" />
      <polyline points={pts} fill="none" stroke={color} strokeWidth="2" strokeLinejoin="round" />
      <circle cx={px(data.length - 1)} cy={py(data[data.length - 1])} r="4" fill={color} />
    </svg>
  );
}
